import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { FileText } from 'lucide-react';
import { MdMeetingRoom } from "react-icons/md";
import styled from 'styled-components';
import Boton from '../eventos/navegacion_y_accion/Boton';
import Titulo from "../basicos/Titulo";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { fetchEditarOficina, fetchOficinaData } from '../../../peticiones_API/PeticionesGestionPersonasOficinas';
import ErrorForm from '../eventos/avisos/Alerta';
import { handleChangeErrors, handleSubmitErrorsOficinas, todosDatosCorrectos } from '../../validacion/ValidationFormDepartamento';
import { DatosCorrectosOficina, ServerNoCreoOficina, DatosIncorrectos } from '../eventos/avisos/VentanaEmergente';
import { ToastContainer, toast } from "react-toastify";
import { getProvincias, getMunicipios, buscarDireccionPorCP, buscarCPPorPoblacion, buscarProvinciaPorNombre } from '../../../utils/direccionesUtils';
import { Button } from 'react-bootstrap';
import { Trash2 } from 'lucide-react';


function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ pt: 3 }}>
            {children}
          </Box>
        )}
      </div>
    );
}

const FormEditarOficina = ({ }) => {
const { Id } = useParams();
const location = useLocation();
const navigate = useNavigate();

const parametrosBusqueda = new URLSearchParams(location.search);
const tabDesdeURL = parametrosBusqueda.get('tab');
const [tabValue, setTabValue] = useState(() => {
    return tabDesdeURL ? parseInt(tabDesdeURL, 10) : 0;
});

const [botonRenderClick, setBotonRenderClick] = useState(false);

const handleCambioTab = (event, newValue) => {
    setTabValue(newValue);
    const nuevosParametrosBusqueda = new URLSearchParams(location.search);
    nuevosParametrosBusqueda.set('tab', newValue.toString());
    navigate(`${location.pathname}?${nuevosParametrosBusqueda.toString()}`, { replace: true });
};

const [formData, setFormData] = useState({
        nombre: '',
        direccion: '',
        cp: '',
        provincia: '',
        poblacion: '',
    });

    const [salas, setSalas] = useState([]);

    const [provinciaId, setProvinciaId] = useState(null);
    const [municipios, setMunicipios] = useState([]);
    const provincias = getProvincias();

    const camposRequeridos = {
        nombre: "Debes insertar un nombre",
        direccion: "Debes insertar una direccion",
        cp: "Debes insertar un codigo postal",
        provincia: "Debes insertar una provincia",
        poblacion: "Debes insertar una poblacion",
    };

    const [estadoCampoReque, setEstadoCampoReque] = useState({
        nombre: null,
        direccion: null,
        cp: null,
        provincia: null,
        poblacion: null,
    });

    let [formCompletado, setFormCompletado] = useState(null);
    const [estadosActualizados, setEstadosActualizados] = useState(false);

    const [errorEnviarForm, setErrorEnviarForm] = useState({
        oficinaDuplicado: null,
        refDuplicado: null

    });

    useEffect(() => {
        async function fetchData() {
            try {
                const oficinaResponse = await fetchOficinaData(Id);
                setFormData({
                    nombre: oficinaResponse.nombre || '',
                    direccion: oficinaResponse.direccion || '',
                    cp: oficinaResponse.cp || '',
                    provincia: oficinaResponse.provincia || '',
                    poblacion: oficinaResponse.poblacion || '',
                    telefono: oficinaResponse.telefono || null,
                    mail: oficinaResponse.mail || null,
                    horario: oficinaResponse.horario || null
                });
                const provId = buscarProvinciaPorNombre(oficinaResponse.provincia);
                setProvinciaId(provId);
                setSalas(oficinaResponse.Salas || []);
            } catch (error) {
                console.error("Error fetching oficina data:", error);
            }
        }
        fetchData();
    }, [Id]);

    useEffect(() => {
        const nuevosMunicipios = getMunicipios(provinciaId);
        setMunicipios(nuevosMunicipios);
    }, [provinciaId]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if(event.target.name === "guardar_cambios_statico"){
            setBotonRenderClick(false);
        }else{         
            setBotonRenderClick(true);
        }

        setFormCompletado(null);
        setErrorEnviarForm({ oficinaDuplicado: null, refDuplicado: null });
        setEstadosActualizados(false);
        
        handleSubmitErrorsOficinas(formData, estadoCampoReque, setEstadoCampoReque, camposRequeridos, setEstadosActualizados);
    };

    useEffect (() => {

        if (estadosActualizados) {

            let validacionTodosDatos = todosDatosCorrectos(formData, estadoCampoReque);
            let todosCamposFalse = validacionTodosDatos.todosCamposFalse();
            (async () => {
                if (todosCamposFalse === true) {
                    try {

                        const oficinaActualizada = {
                            ...formData,
                            salas: salas.map(sala => {
                                if (sala.isNew) {
                                    return { 
                                        nombre: sala.nombre,
                                        id_oficina: parseInt(Id)
                                    };
                                }
                                return {
                                    Id: sala.Id,
                                    id_oficina: sala.id_oficina,
                                    nombre: sala.nombre
                                };
                            })
                        };
                        await fetchEditarOficina(Id, oficinaActualizada);
                        setFormCompletado(true);
                        //console.log("Oficina creada: ", response);

                    } catch (error) {

                        console.error(error);

                        if (error?.response?.data?.error === 'REGISTRO_DUPLICADO') {
                            setErrorEnviarForm(prevFormData => ({ ...prevFormData, oficinaDuplicado: true }));
                        }
                        setFormCompletado(false);

                    }
                } else {
                    toast.error("Faltan campos por rellenar")
                }
                setEstadosActualizados(false);
            })();
        }
    }, [estadosActualizados, formData, estadoCampoReque, Id, salas])

    const handleChange = (event) => {

        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo

        const { name, value } = event.target;

        setFormData(prev => ({ ...prev, [name]: value }));

        if (name === 'cp' && value.length === 5) {
            const address = buscarDireccionPorCP(value);
            if (address) {
                setFormData(prev => ({
                    ...prev,
                    ...address,
                    cp: value
                }));
                setProvinciaId(address.provinciaId);
            }
        }

        if (name === 'provincia') {
            const provId = buscarProvinciaPorNombre(value);
            setProvinciaId(provId);
            setFormData(prev => ({ ...prev, provincia: value, poblacion: '', cp: '' }));
        }

        if (name === 'poblacion') {
            const cp = buscarCPPorPoblacion(formData.provincia, value);
            if (cp) {
                setFormData(prev => ({ ...prev, cp: cp }));
            }
        }

        if (name in estadoCampoReque) {
            handleChangeErrors(name, value, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
        }

        console.log("FormData actualizado: ", formData);
    }

    const handleAgregarSala = (event) => {
        event.preventDefault();
        const nuevaSalaObj = {
            nombre: '',
            isNew: true
        };

        setSalas([...salas, nuevaSalaObj]);
    };

    const handleEliminarSala = (event, sala) => {
        event.preventDefault();
        setSalas(salas.filter(s => {
            if (sala.isNew) {
                return s.nombre !== sala.nombre || !s.isNew;
            }
            return s.Id !== sala.Id;
        }));
        //toast.success("Sala eliminada");
    };



    return ( 
        <>
            <Form>
                <CabeceraForm>
                    <Titulo texto="EDITAR UNA OFICINA" />
                </CabeceraForm>

                <Container>
                    <ToastContainer/>
                    <Col>
                        {/* Tabs de navegación */}
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={tabValue} onChange={handleCambioTab} aria-label="Pestañas de formulario">
                                <Tab 
                                    label="GENERAL" 
                                    icon={<FileText size={20} />} 
                                />
                                <Tab 
                                    label="SALAS" 
                                    icon={<MdMeetingRoom size={20} />} 
                                />
                            </Tabs>
                        </Box>

                        {/* Contenido de la pestaña General */}
                        <TabPanel value={tabValue} index={0}>
                        <Row md="3">
                            <Form.Group className="mb-12">
                                <TituloCategoria>Nombre <span>*</span></TituloCategoria>
                                <Form.Control type='text' name='nombre' value={formData.nombre || ''} onChange={handleChange} />
                                <ErrorForm mensaje={camposRequeridos.nombre} estadoAlerta={estadoCampoReque.nombre} />
                            </Form.Group>

                            <Form.Group className="mb-12">
                                <TituloCategoria>Telefono</TituloCategoria>
                                <Form.Control type='text' name='telefono' value={formData.telefono || ''} onChange={handleChange} />
                                <ErrorForm mensaje={camposRequeridos.telefono} estadoAlerta={estadoCampoReque.telefono} />
                            </Form.Group>

                            <Form.Group className="mb-12">
                                <TituloCategoria>Email</TituloCategoria>
                                <Form.Control type='mail' name='mail' value={formData.mail || ''} onChange={handleChange} />
                                <ErrorForm mensaje={camposRequeridos.mail} estadoAlerta={estadoCampoReque.mail} />
                            </Form.Group>
                        </Row>

                        <Row md="3">
                            <Form.Group className="mb-12">
                                <TituloCategoria>Direccion <span>*</span></TituloCategoria>
                                <Form.Control type='text' name='direccion' value={formData.direccion || ''} onChange={handleChange} />
                                <ErrorForm mensaje={camposRequeridos.direccion} estadoAlerta={estadoCampoReque.direccion} />
                            </Form.Group>

                            <Form.Group className='mb-12'>
                                <TituloCategoria>Provincia <span>*</span></TituloCategoria>
                                <Form.Select value={formData.provincia || ''} name="provincia" onChange={handleChange}>
                                    <option value=""></option>
                                    {provincias.sort((a, b) => a.localeCompare(b)).map((provincia, index) => (
                                        <option key={index} value={provincia}>
                                            {provincia}
                                        </option>
                                    ))}
                                </Form.Select>
                                <ErrorForm mensaje={camposRequeridos.provincia} estadoAlerta={estadoCampoReque.provincia} />
                            </Form.Group>

                            <Form.Group className='mb-12'>
                                <TituloCategoria>Población <span>*</span></TituloCategoria>
                                <Form.Select value={formData.poblacion || ''} name="poblacion" onChange={handleChange}>
                                    <option value=""></option>
                                    {municipios.map((poblaciones, index) => (
                                        <option key={index} value={poblaciones.name}>
                                            {poblaciones.name}
                                        </option>
                                    ))}
                                </Form.Select>
                                <ErrorForm mensaje={camposRequeridos.poblacion} estadoAlerta={estadoCampoReque.poblacion} />
                            </Form.Group>
                        </Row>

                        <Row md="3">
                            <Form.Group className="mb-12">
                                <TituloCategoria>Codigo Postal <span>*</span></TituloCategoria>
                                <Form.Control type='number' name='cp' value={formData.cp || ''} onChange={handleChange} />
                                <ErrorForm mensaje={camposRequeridos.cp} estadoAlerta={estadoCampoReque.cp} />
                            </Form.Group>

                            <Form.Group className="mb-12">
                                <TituloCategoria>Horario</TituloCategoria>
                                <Form.Control as="textarea" rows={5} name='horario' value={formData.horario || ''} onChange={handleChange} placeholder={`Ej:
Lunes-Viernes: 08:00-14:00
Sabados: 09:00-13:00
Domingos: Cerrado`} />
                                <ErrorForm mensaje={camposRequeridos.horario} estadoAlerta={estadoCampoReque.horario} />
                            </Form.Group>
                        </Row>
                        </TabPanel>

                        {/* Contenido de la pestaña Salas */}
                        <TabPanel value={tabValue} index={1}>
                            <Row className="mt-3">
                                <Col>
                                    <Button 
                                        variant="success"
                                        onClick={handleAgregarSala}
                                        className='mb-4'
                                        style={{
                                            height: '50px',
                                            backgroundColor: '#003c66',
                                            fontSize: '18px',
                                            border: '1px solid #003c66',
                                            transition: 'background-color 0.3s, color 0.3s, border-color 0.3s'
                                        }}
                                        onMouseOver={e => {
                                            e.target.style.backgroundColor = 'white';
                                            e.target.style.color = '#003c66';
                                            e.target.style.borderColor = '#003c66';
                                        }}
                                        onMouseOut={e => {
                                            e.target.style.backgroundColor = '#003c66';
                                            e.target.style.color = 'white';
                                            e.target.style.borderColor = '#003c66';
                                        }}
                                    >
                                        + Añadir Sala
                                    </Button>
                                </Col>
                            </Row>
                            {salas.map((sala, index) => (
                                <Row className="mb-3" key={sala.Id || `nuevo-${index}`}>
                                    <Col md={10}>
                                        <Form.Group>
                                            <TituloCategoria>Sala {index + 1}</TituloCategoria>
                                            <Form.Control
                                                type="text"
                                                value={sala.nombre}
                                                onChange={(e) => {
                                                    const nuevasSalas = [...salas];
                                                    nuevasSalas[index] = { ...sala, nombre: e.target.value };
                                                    setSalas(nuevasSalas);
                                                }}
                                                placeholder="Nombre de la sala"
                                                className="py-3"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs="auto" className="d-flex align-items-center" style={{ paddingTop: '35px' }}>
                                        <Button 
                                            variant="danger"
                                            onClick={(event) => handleEliminarSala(event, sala)}
                                            style={{ height: '50px', width: '50px' }}
                                        >
                                            <Trash2 />
                                        </Button>
                                    </Col>
                                </Row>
                            ))}
                        </TabPanel>

                        <Row className="mt-4">
                            <ContenedorBotones>

                                <Boton
                                    bonificados="true"
                                    grande="true"
                                    as="button"
                                    primario="true"
                                    type="submit"
                                    onClick={handleSubmit}
                                    form="true"
                                    name='guardar_cambios_statico'
                                >
                                    Guardar
                                </Boton>

                                <Boton
                                    bonificados="true"
                                    grande="true"
                                    as="button"
                                    primario="true"
                                    type="submit"
                                    onClick={handleSubmit}
                                    form="true"
                                >
                                    Guardar y Salir
                                </Boton>
                                <Boton
                                    grande="true"
                                    to="/gestionpersonas/oficinas"
                                >
                                    Cancelar
                                </Boton>
                            </ContenedorBotones>
                        </Row>
                    </Col>
                </Container>
            </Form>

            {botonRenderClick ?  //Hay un error cuando se editan las cosas en oficinas
               <DatosCorrectosOficina envioActivado={formCompletado} />         
                :             
               <DatosCorrectosOficina envioActivado={formCompletado} redirect={false} />
            }

            <DatosIncorrectos envioActivado={formCompletado} duplicado={errorEnviarForm.oficinaDuplicado} />
            <ServerNoCreoOficina envioActivado={formCompletado === false && !errorEnviarForm.oficinaDuplicado} />
        </>
     );
}

const CabeceraForm = styled.div`
    margin: 2% 0% 2% 35%;
`

const ContenedorBotones = styled.div`
    margin-top: 30%;
`

const TituloCategoria = styled(Form.Label)`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 15.6px;
    line-height: 1.8;
    color: #4a4a4a;

    span{
        color: #ff0000;
        font-weight: 400;
    }
`
 
export default FormEditarOficina;